import {
    getFilledProficiencyBarsCount,
    isValidProficiencyLevelIndex,
} from './proficiencyLevelBarsRule';

interface ProficiencyLevelBarsProps {
    levelIndex: number;
    totalLevels: number;
    color: string;
    dataTestId?: string;
}

const BAR_BASE_HEIGHT_PX = 4;
const BAR_HEIGHT_STEP_PX = 1.5;
const BAR_WIDTH_CLASS = 'w-1';
const BAR_RADIUS_CLASS = 'rounded-[1px]';
const BAR_GAP_CLASS = 'gap-[3px]';
const EMPTY_BAR_BACKGROUND_CLASS = 'bg-base-200';
const BAR_SHAPE_CLASS = `${BAR_WIDTH_CLASS} ${BAR_RADIUS_CLASS}`;
const EMPTY_BAR_CLASS = `${BAR_SHAPE_CLASS} ${EMPTY_BAR_BACKGROUND_CLASS}`;

export const ProficiencyLevelBars = ({
    levelIndex,
    totalLevels,
    color,
    dataTestId = 'proficiency-level-bars',
}: ProficiencyLevelBarsProps) => {
    if (!isValidProficiencyLevelIndex({ levelIndex, totalLevels })) {
        return null;
    }

    const filledCount = getFilledProficiencyBarsCount({ levelIndex, totalLevels });
    const barPositions = Array.from({ length: totalLevels }, (_, index) => index + 1);

    return (
        <div
            className={`flex items-end ${BAR_GAP_CLASS}`}
            data-testid={dataTestId}
            aria-hidden={'true'}
        >
            {barPositions.map((position) => {
                const isFilled = position <= filledCount;

                return (
                    <span
                        key={position}
                        data-testid={`${dataTestId}-bar-${position}`}
                        className={isFilled ? BAR_SHAPE_CLASS : EMPTY_BAR_CLASS}
                        style={{
                            height: `${BAR_BASE_HEIGHT_PX + position * BAR_HEIGHT_STEP_PX}px`,
                            backgroundColor: isFilled ? color : undefined,
                        }}
                    />
                );
            })}
        </div>
    );
};
